<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .footer {
    display: flex;
    justify-content: flex-end;
    padding: utils.in_rem(12px);
    border-top: solid 1px colors.get(interfaceSwGrey_10);
    gap: utils.in_rem(16px);
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { teamStore } from "../../../../api-stores/license-store";
  import { adminModify } from "../../../../api/admin";
  import {
    assignLicenseModalProps,
    hasSignInLicense,
    selectedLicenses,
  } from "./stores";

  let { clientHeight = $bindable(), onclose = () => {} } = $props();

  const saveChanges = async () => {
    const changes = [];
    Object.entries($selectedLicenses).forEach(([licenseKind, isSelected]) => {
      const hadLicense =
        $assignLicenseModalProps.originalLicenses.includes(licenseKind);

      if (hadLicense !== isSelected) {
        changes.push({
          userId: $assignLicenseModalProps.userId,
          teamId: $teamStore.teamId,
          license: licenseKind,
          operation: isSelected ? "add" : "remove",
        });
      }
    });

    if (changes.length > 0) {
      await adminModify({
        kind: "user",
        data: {
          userId: $assignLicenseModalProps.userId,
          kind: $assignLicenseModalProps.kind,
        },
      });
      await adminModify({
        kind: "assign-licenses",
        data: { changes },
      });

      await teamStore.get();

      showToast({
        title: "Success",
        type: "success",
        subtitle: "Licenses assigned successfully",
      });
    }

    onclose();
  };
</script>

<div class="footer" bind:clientHeight>
  <Button kind="tertiary" onclick={onclose}>Cancel</Button>
  {#if $hasSignInLicense}
    <Button kind="primary" onclick={saveChanges}>Confirm & Save</Button>
  {:else}
    <ButtonWithTooltip kind="primary" class="disabled">
      Confirm & Save
      <span slot="tooltip">
        You won't be able to sign in unless you assign yourself licenses now
      </span>
    </ButtonWithTooltip>
  {/if}
</div>
